import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find } from '@fretadao/f-js-dom';


application.register('table-sort', class extends Controller {
  static values = {
    filterCol: Number
  };

  sortByName(reverse = false) {
    const table = find('[data-element="table"]');
    const tableBody = table.tBodies[0];
    let tableRows = Array.prototype.slice.call(tableBody.rows, 0);

    tableRows = this.sortRows(tableRows);
    reverse ? tableRows.reverse() : null;

    tableRows.forEach((row) => {
      tableBody.appendChild(row);
    })
  }

  ascendingOrder() {
    this.sortByName()
  }

  descendingOrder() {
    this.sortByName(true)
  }

  sortRows(tableRows) {
    return tableRows.sort((a, b) => {
      return this.compareValuesInsideRows(a, b);
    });
  }

  compareValuesInsideRows(row1, row2) {
    return row1.cells[this.filterColValue].textContent.toLowerCase().trim()
            .localeCompare(row2.cells[this.filterColValue].textContent.toLowerCase().trim());
  }
});
